import { useEffect, useState } from "react";
import { Star, X, Heart } from "lucide-react";
import { GOOGLE_REVIEW } from "@/data/business";

const SEEN_KEY = "pgdr_review_nudge_seen";

export default function ReviewNudge() {
  const [show, setShow] = useState(false);
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(SEEN_KEY)) return;
    const reviews = document.getElementById("reviews");
    if (!reviews) return;

    let done = false;
    let seenReviews = false;
    const onScroll = () => {
      if (done) return;
      const rect = reviews.getBoundingClientRect();
      // mark once the reviews section has entered the viewport
      if (rect.top < window.innerHeight * 0.8) seenReviews = true;
      // trigger once they've read a few and started scrolling past the section
      if (seenReviews && rect.bottom < window.innerHeight * 0.4) {
        done = true;
        setShow(true);
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const dismiss = () => {
    localStorage.setItem(SEEN_KEY, "1");
    setLeaving(true);
    setTimeout(() => setShow(false), 300);
  };

  if (!show) return null;

  return (
    <div
      className={`fixed z-[60] bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:bottom-6 sm:w-[360px] transition-all duration-300 ${
        leaving ? "opacity-0 translate-y-3" : "opacity-100 translate-y-0"
      }`}
      data-testid="review-nudge"
    >
      <div className="relative bg-white rounded-xl shadow-2xl shadow-slate-900/20 ring-1 ring-slate-900/5 p-5 pr-9">
        <button
          onClick={dismiss}
          className="absolute top-3 right-3 text-slate-400 hover:text-slate-700"
          aria-label="Close"
          data-testid="review-nudge-close"
        >
          <X className="h-4 w-4" />
        </button>
        <div className="flex items-start gap-3">
          <span className="grid place-items-center h-10 w-10 shrink-0 rounded-full bg-red-600/10">
            <Heart className="h-5 w-5 fill-red-500 text-red-500" />
          </span>
          <div>
            <p className="font-heading font-bold text-slate-900 leading-snug">
              Been a customer? We'd love your review 🙏
            </p>
            <p className="mt-1 text-sm text-slate-600 leading-relaxed">
              We're a locally owned small business — a quick 30-second Google review means the world to us.
            </p>
          </div>
        </div>
        <div className="mt-4 flex items-center gap-2">
          <a
            href={GOOGLE_REVIEW.url}
            target="_blank"
            rel="noopener noreferrer"
            onClick={dismiss}
            className="flex-1 inline-flex items-center justify-center gap-2 bg-[#4285F4] hover:bg-[#3367d6] text-white font-bold text-sm px-4 py-2.5 rounded-sm transition-colors"
            data-testid="review-nudge-cta"
          >
            <Star className="h-4 w-4 fill-white" /> Leave a Google Review
          </a>
          <button
            onClick={dismiss}
            className="text-sm font-semibold text-slate-500 hover:text-slate-800 px-3 py-2.5"
            data-testid="review-nudge-dismiss"
          >
            Maybe later
          </button>
        </div>
      </div>
    </div>
  );
}
